import { TreeItem, TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { UtilitySpacesRootTreeItem } from '../components/UtilitySpacesRootTreeItem.js'
import { SimpleTreeItemData } from '../types.js'

export const UTILITY_SPACES_INDEX = 'utility-spaces'

export function createUtilitySpacesRootTreeItem(
  { $t }: I18nShape,
  {
    children,
  }: {
    children: TreeItemIndex[]
  },
): TreeItem<SimpleTreeItemData> {
  return {
    index: UTILITY_SPACES_INDEX,
    isFolder: true,
    data: {
      type: 'simple',
      title: $t({
        id: 'Generics.UtilitySpaces',
        defaultMessage: 'Utility {SPACES}',
      }) as string,
      render: UtilitySpacesRootTreeItem,
    },
    children,
  }
}
